import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropFretePorConta } from 'utils/drops';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import VirtualDrop from 'components/VirtualDrop';
import InputMask from 'components/InputMask';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'FormaDeEnvio';
  const defaultValues = {
    descricao: '',
    transportadora_id: null,
    fretepc: null,
    integra_access_id: null,
    especie: '',
    quantidade: '',
    inivalid: null,
    fimvalid: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops, getDrops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
        getDrops(['FormaDeEnvio']);
      },
    });

  return (
    <Container>
      <Header
        titulo={(Boolean(state) ? 'Editar' : 'Cadastrar') + ' Forma de Envio'}
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input name="descricao" control={control} label="Descrição" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <VirtualDrop
              control={control}
              name="transportadora_id"
              label="Transportadora"
              options={drops?.EntidadeTipo?.filter(
                (t) => t?.tipo === 'TRANSPORTADOR'
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="fretepc"
              control={control}
              label="Frete por Conta"
              options={dropFretePorConta}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="integra_access_id"
              control={control}
              label="Integração"
              options={drops?.IntegraAccess}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Input name="especie" control={control} label="Espécie" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="quantidade" control={control} label="Quantidade" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              type="date"
              control={control}
              name="inivalid"
              label="Data de Início"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              type="date"
              control={control}
              name="fimvalid"
              label="Data de Término"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
